import React from 'react';
import { HeaderGroup } from 'react-table';
import { IBalanceInstruction } from '../../../../../../sp-types/balanceFlowType';

interface TableHeaderProps {
  headerGroups: HeaderGroup<IBalanceInstruction>[];
}
export const ExecutionTableHeader: React.FC<TableHeaderProps> = ({ headerGroups }) => (
  <thead className="mb-[1rem]">
    {headerGroups.map((headerGroup, index) => (
      <tr {...headerGroup.getHeaderGroupProps()} key={index}>
        {headerGroup.headers.map((column) => (
          <th
            {...column.getHeaderProps()}
            className="bg-gray-50 text-secondary_text font-normal text-sm py-[0.5rem] ps-[1rem] border border-gray-200"
            key={column.id}
          >
            {column.render('Header')}
          </th>
        ))}
      </tr>
    ))}
  </thead>
);
